import type { FormItem } from "@/types";

type ExpandItem = (item: FormItem) => FormItem;

const expandItem: ExpandItem = (item) => {
  const newItem = { ...item, ...item.data };
  delete newItem.data;
  if (item.item_type === 'check_box' && !newItem.form_content) newItem.form_content = false;
  return newItem;
};

export { expandItem };
